import React from "react";
import { Card } from "react-bootstrap";
function FbInfo() {
  return (
    <Card>
      <Card.Header>
        Facebook-ээ ашиглаж TodToli апп-д бүртгэл үүсгэх
      </Card.Header>
      <Card.Body>
        <ul>
          <li>
            <Card.Text>
              Хэрэглэгч өөрийн Facebook хаягаа ашиглаж апп-д бүртгүүлэх
              боломжтой.
            </Card.Text>
          </li>
          <li>
            <Card.Text>
              TodToli апп нь хэрэглэгчийн зөвшөөрөлтэйгөөр зөвхөн public
              өгөгдлийн аван бүртгэл үүсгэдэг.
              <br /> <b>Үүнд:</b>
              <br /> Нэр, зураг, и-мейл хаяг гэсэн өгөгдлүүд орж байна.
            </Card.Text>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
}
export default FbInfo;
